import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, CalendarDays, ClipboardList, FileText, Users, BookOpen, BookMarked, Award } from 'lucide-react';

const LINKS = [
  { to: '/member-dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/member-calendar', label: 'Calendar', icon: CalendarDays },
  { to: '/member-info', label: 'My Info Form', icon: ClipboardList },
  { to: '/meeting-minutes', label: 'Minutes', icon: FileText },
  { to: '/member-directory', label: 'Directory', icon: Users },
  { to: '/officers', label: 'Officers', icon: Award },
  { to: '/book-club', label: 'Book Club', icon: BookOpen },
  { to: '/leadership-library', label: 'Leadership', icon: BookMarked },
];

export const MemberQuickNav = () => {
  const { pathname } = useLocation();

  return (
    <nav
      className="flex flex-wrap justify-center gap-2 mb-10 print:hidden"
      data-testid="member-quick-nav"
      aria-label="Member portal navigation"
    >
      {LINKS.map(({ to, label, icon: Icon }) => {
        const active = pathname === to;
        return (
          <Link
            key={to}
            to={to}
            data-testid={`quick-nav-${to.replace('/', '')}`}
            className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm border transition-colors ${
              active
                ? 'bg-[#5d6b3c] text-white border-[#5d6b3c]'
                : 'bg-white/80 text-[#3c4a2a] border-[#bd8cae]/40 hover:border-[#5d6b3c] hover:text-[#5d6b3c]'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
};
